export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        const f = vnode.context[binding.expression];
        if (typeof f === 'function') {
          f(event);
        }
      }
    };
    document.body.addEventListener('mousedown', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('mousedown', el.clickOutsideEvent);
  },
};
